module.exports = __webpack_public_path__ + "img/micad.eb79831b.svg";